import { IEvent } from '@interfaces/event';

import { env } from 'env';

const { REACT_APP_EVENT_CAROUSEL_HIDE_EXTERNAL_EVENT_TAGS } = env;

const hideEventTags = (REACT_APP_EVENT_CAROUSEL_HIDE_EXTERNAL_EVENT_TAGS || '')
  .split(',')
  .map((i) => i.trim());

export const filterVisibleEvents = (events: IEvent[]) => {
  if (hideEventTags.length > 0) {
    // Filter out external events
    return events.filter(({ eventTags }) => {
      if (eventTags) {
        return (
          eventTags.filter((tag) => !hideEventTags.includes(tag)).length ===
          eventTags.length
        );
      }
      return true;
    });
  }

  return events;
};

export const isExternalEvent = (event: IEvent) =>
  event?.eventTags && event?.eventTags.indexOf('External') > -1;
